import timelineSelectors from './timeline';

export const animationsSelectors = {
  getAnimations: (state) => state.animations.present,
  getCurrentAnimation: (state) => Object.values(state.animations.present)
    .map(({ items }) => items)
    .flat()
    .find(({ id }) => id === timelineSelectors.getSelectedAnimation(state)),
};
